import type { CardProps } from 'src/notifications/cardTypes';
import { formatShortDate } from 'src/utils/dateFormatting';
import NotificationCardShell from '../NotificationCardShell';
import NotificationDetailRow from '../NotificationDetailRow';
import NotificationLinkButton from '../NotificationLinkButton';

export default function ProtectionExpiringCard({
  notification,
  payload,
  onClose,
}: CardProps<'PROTECTION_EXPIRING'>) {
  return (
    <NotificationCardShell
      notification={notification}
      title="Protection policy expiring"
      body="A protection policy is expiring soon."
      clientId={payload.client_id}
      details={
        <>
          <NotificationDetailRow label="Expires" value={formatShortDate(payload.term_end_date)} />
          {payload.provider && <NotificationDetailRow label="Provider" value={payload.provider} />}
        </>
      }
      actions={
        <>
          <NotificationLinkButton to={`/client/${payload.client_id}`} onClose={onClose}>
            View client
          </NotificationLinkButton>
          <NotificationLinkButton
            primary
            to={`/client/${payload.client_id}/financial-items/Protection/${payload.protection_id}`}
            onClose={onClose}
          >
            View policy
          </NotificationLinkButton>
        </>
      }
    />
  );
}
